import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  LinkCard: styled(Flex, {
    backgroundColor: '$backgroundTertiary',
    borderRadius: '$small',
    flexDirection: 'column',
    alignItems: 'start',
    gap: '$4',
    padding: '$4',
    marginBottom: '$10',
    width: '100%',

    '@tablet': {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  }),
};

export default styles;
